import { useMemo } from 'react';

export const useCertification = (
  has_certification_a: boolean | undefined,
  has_certification_b: boolean | undefined,
  has_certification_c: boolean | undefined,
) => {
  return useMemo(() => {
    const certs = [];
    if (has_certification_a) certs.push('A');
    if (has_certification_b) certs.push('B');
    if (has_certification_c) certs.push('C');
    return certs;
  }, [has_certification_a, has_certification_b, has_certification_c]);
};
